import { Component } from '@angular/core';
import { CustomLoader, LANGUAGE, TRANSLATION_ACTIONS } from 'army-builder-shared';
import { Store } from '@ngrx/store';

import { GAME_IDS } from '../../game-id.token';
import { WarlordUserService } from '../user/user.service';
import { SubscriptionService } from '../../subscription/subscription.service';

@Component({
    standalone: false,
    selector: 'wl-account-actions-page',
    template: `
        <div class="gutter-padding">
            <h2>{{ 'GLOBAL.SETTINGS.ACCOUNT.ACTIONS.TITLE' | translate }}</h2>
            <abs-account-settings
                [logout]="userService.logout.bind(userService)"
                (deleteAccountConfirmed)="userService.deleteAccount()"
            >
                <ng-template #deleteConfirmContent>
                    @if (subscriptionService.userHasAccess()) {
                        <p>{{ 'GLOBAL.SETTINGS.ACCOUNT.DELETE.ARE_YOU_SURE_SUBSCRIBER' | translate }}</p>
                        <p>
                            {{ 'GLOBAL.SUBSCRIPTION.CANCEL_' + subscriptionService.subscriptionPlatform() | translate }}
                        </p>
                    } @else {
                        <p>{{ 'GLOBAL.SETTINGS.ACCOUNT.DELETE.ARE_YOU_SURE' | translate }}</p>
                    }
                </ng-template>
            </abs-account-settings>

            <div class="buttons">
                <ion-button (click)="refreshLanguageData()">Refresh language data</ion-button>
            </div>
        </div>
    `,
    styles: [
        `
            .buttons {
                margin-left: 0;
                margin-right: 0;
            }
        `
    ]
})
export class AccountActionsPage {
    constructor(
        public userService: WarlordUserService,
        public subscriptionService: SubscriptionService,
        private store: Store,
        private warlordCustomLoader: CustomLoader
    ) {}

    refreshLanguageData() {
        const gameIds = ['global', ...Object.values(GAME_IDS)];

        const lang = LANGUAGE;

        this.store.dispatch(TRANSLATION_ACTIONS.SHOW_TRANSLATION_PRELOAD_MODAL());
        for (let gameId of gameIds) {
            this.store.dispatch(TRANSLATION_ACTIONS.TRANSLATION_LOADING({ gameId, lang }));
            this.warlordCustomLoader.loadData(gameId, LANGUAGE, false);
        }
    }
}
